import { render } from "./ctrl-bet-box.vue?vue&type=template&id=c21641ec&scoped=true&ts=true"
import script from "./ctrl-bet-box.vue?vue&type=script&lang=ts"
export * from "./ctrl-bet-box.vue?vue&type=script&lang=ts"

import "./ctrl-bet-box.vue?vue&type=style&index=0&id=c21641ec&lang=scss&scoped=true"

import exportComponent from "D:\\project\\newD\\floor30-ws-with-server-selection\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c21641ec"]])

export default __exports__